module.exports = __webpack_public_path__ + "assets/c7c469244d5386d3792111a331c6d231.mp3";


/*****************
 ** WEBPACK FOOTER
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/sounds/buttons/lines/line_4.mp3
 ** module id = 54
 ** module chunks = 0
 **/